import qs from 'qs';
import * as facetActions from '../store/actions/facetActions';

const SEARCH_PAGE_SIZE = 10;

const reconcilePubYears = (current, updated) => {
  const reconciled = Object.assign(
    {},
    ...Object.keys(current).map(k => ({
      [k]: Object.assign(
        {},
        { ...current[k], value: updated[k] ? updated[k].value : 0 }
      ),
    }))
  );
  return reconciled;
};

const reconcileFilterCount = (currentFilter, updatedFilter, filterName) => {
  if (filterName === 'pubYears') {
    return reconcilePubYears(currentFilter, updatedFilter);
  }

  const allReconciled = currentFilter.map(c => {
    const match = updatedFilter.find(u => u.key.id === c.key.id);
    const reconciled = Object.assign(
      {},
      { ...c, count: match ? match.count : 0 }
    );
    return reconciled;
  });

  return allReconciled;
};
const allFiltersOff = (filters, filterName) => {
  if (filterName === 'pubYears') {
    return !Object.keys(filters)
      .map(k => filters[k].selected)
      .reduce((acc, curr) => acc || curr, false);
  }

  return !filters
    .map(x => x.selected)
    .reduce((acc, curr) => acc || curr, false);
};
const recalculateFilters = (
  currentFilters,
  updatedFilters,
  updatedSectionName
) => {
  if (!updatedSectionName || updatedSectionName === '') {
    return currentFilters;
  }

  const reconciledValues = Object.assign(
    {},
    ...Object.keys(updatedFilters).map(k => ({
      [k]:
        k === updatedSectionName && !allFiltersOff(currentFilters[k], k)
          ? currentFilters[k]
          : reconcileFilterCount(currentFilters[k], updatedFilters[k], k),
    }))
  );

  return reconciledValues;
};

const calculateSearchPaginingIndices = (
  currentPage,
  pageSize = SEARCH_PAGE_SIZE
) => {
  const currPageIndex = currentPage - 1;
  const start = currPageIndex * pageSize;
  const end = start + (pageSize - 1);

  return { startIndex: start, endIndex: end };
};

const addSelector = o => Object.assign({}, o, { selected: false });

const augmentPubYear = pubYearData => {
  const augmented = Object.assign(
    {},
    ...Object.keys(pubYearData).map(k => ({
      [k]: { value: pubYearData[k], selected: false },
    }))
  );

  return augmented;
};

const augumentFilters = searchData => ({
  systematicReviews: (searchData.systematicReviewCounts || []).map(x => addSelector(x)),
  guidelineQuality: (searchData.guidelineQualityCounts || []).map(x => addSelector(x)),
  guidelineRateQuality: (searchData.guidelineRateQualityCounts || []).map(x => addSelector(x)),  
  inclusions: (searchData.criteriaCounts || []).map(x => addSelector(x)),
  pubYears: augmentPubYear(searchData.publicationYearCounts || {}),
  organizations: (searchData.organizationCounts || []).map(x => addSelector(x)),
  interventions: (searchData.interventionCounts || []).map(x => addSelector(x)),
  clinicalAreas: (searchData.clinicalAreaCounts || []).map(x => addSelector(x)),
  patientAges: (searchData.patientAgeCounts || []).map(x => addSelector(x)),
});

const clearAllFilters = filters => {
  const cleared = {    
    inclusions: filters.inclusions.map(x => ({ ...x, selected: false })),
    organizations: filters.organizations.map(x => ({ ...x, selected: false })),
    interventions: filters.interventions.map(x => ({ ...x, selected: false })),
    clinicalAreas: filters.clinicalAreas.map(x => ({ ...x, selected: false })),
    patientAges: filters.patientAges.map(x => ({ ...x, selected: false })),
    pubYears: Object.assign(
      {},
      ...Object.keys(filters.pubYears).map(k => ({
        [k]: { value: filters.pubYears[k].value, selected: false },
      }))
    ),
  };

  return cleared;
};

const extractSearchString = location => {
  if (location && location.state && location.state.searchPhrase) {
    return location.state.searchPhrase;
  }

  const decoded = decodeURIComponent(location.search);
  const decodedParsed = qs.parse(decoded, { ignoreQueryPrefix: true });
  if (decodedParsed && decodedParsed['?q']) {
    return decodedParsed['?q'];
  }

  if (decodedParsed && decodedParsed['??q']) {
    return decodedParsed['??q'];
  }

  if (decodedParsed && decodedParsed['q']) {
    return decodedParsed['q'];
  }

  return '';
};

const extractSearchParams = location => {
  if (location) {
    const decoded = decodeURIComponent(location.search);
    const decodedParsed = qs.parse(decoded, { ignoreQueryPrefix: true });
    if (decodedParsed) {
      const result = Object.assign(
        {},
        ...Object.keys(decodedParsed)
          .filter(x => !x.startsWith('?'))
          .map(x => ({ [x]: decodedParsed[x] }))
      );

      return result;
    }

    return {};
  }

  return {};
};

const runFilterUpdate = (area, id, newValue, filters, dispatch) => {
  if (area === 'resetAll') {
    dispatch(facetActions.facetRemovedAction([], 0));
    return clearAllFilters(filters);
  }
  if (area === 'pubYears') {
    const { pubYears } = filters;
    if (pubYears[id] && pubYears[id].selected !== newValue) {
      const updValue = Object.assign({}, pubYears, {
        [id]: { value: pubYears[id].value, selected: newValue, title: id },
      });

      const updatedPubFilters = {
        ...filters,
        pubYears: updValue,
      };

      return updatedPubFilters;
    }
    return filters;
  }

  const filterSection = filters[area];

  const updFilterVals = filterSection.map(x => {
    if (x.key.id === id) {
      return Object.assign({}, x, { selected: newValue, title: x.key.title });
    }

    return x;
  });

  const updFilters = {
    ...filters,
    [area]: updFilterVals,
  };

  return updFilters;
};
export {
  recalculateFilters,
  calculateSearchPaginingIndices,
  SEARCH_PAGE_SIZE,
  augumentFilters,
  extractSearchString,
  runFilterUpdate,
  extractSearchParams,
};
